
import {StatusCatalog} from "./StatusCatalog"
import {StatusItem, StatusLikeCode, VisitRequirement} from "./status.types"
import {signature} from "./consts"

export type StatusProgressRelation = "before_selected" | "at_selected" | "after_selected"

export const getVisitRequirement = (status: StatusItem): VisitRequirement => {
    // Diamond достигается не обычным количеством услуг, а одним визитом от 10000 рублей.
    if (status.code === "diamond") {
        return {type: "single_visit_amount", amount: 10000}
    }

    return {type: "services_count"}
}

export const getServicesCountRequirement = (status: StatusItem): number => {
    // Эти значения повторяют старую логику по order: до Signature нужна 1 услуга,
    // для Signature - 3, для Diamond блок услуг не основной, но текст использует 2.
    if (status.code === signature.code) {
        return 3
    }

    if (status.code === "diamond") {
        return 2
    }

    return 1
}

export const shouldUseLightCompletedBlock = (status: StatusItem, catalog: StatusCatalog): boolean => {
    return catalog.isHigherOrEqual(status, signature.code)
}

export const getRequiredRankForStatus = (status: StatusItem, catalog: StatusCatalog): StatusItem | null => {
    // Явное need_rank важнее предыдущего статуса: Diamond должен требовать Signature.
    if (status.need_rank) {
        return catalog.getByCode(status.need_rank) ?? null
    }

    if (catalog.isFirst(status)) {
        return null
    }

    const previousStatus = catalog.previousOf(status)
    // Start участвует в сравнениях, но не должен отображаться как требуемый ранг.
    if (previousStatus && catalog.isFirst(previousStatus)) {
        return null
    }

    return previousStatus
}

export const getStatusProgressRelation = (
    current: StatusItem | StatusLikeCode,
    selected: StatusItem | StatusLikeCode,
    catalog: StatusCatalog
): StatusProgressRelation => {
    // Используется UI статусов: выбранный статус сравнивается с текущим напрямую,
    // а не с предыдущим рангом, иначе start -> bronze превращается в "сохранение".
    if (catalog.isBefore(current, selected)) {
        return "before_selected"
    }

    if (catalog.isAfter(current, selected)) {
        return "after_selected"
    }

    return "at_selected"
}
